/** Pet / place icons from public/assets — one per day for the unlock seal. */
export const UNLOCK_ICONS = [
  "/assets/IMG-20250110-chokiyawn.jpg",
  "/assets/IMG-20250110-trusunshine.jpg",
  "/assets/IMG-20250110-chopancho.jpg",
  "/assets/IMG-20250110-choconfi.jpg",
  "/assets/IMG-20250110-chosupine.jpg",
  "/assets/IMG-20250110-cindor.jpg",
  "/assets/IMG-20250110-kiwinap.jpg",
  "/assets/IMG-20250110-kiwipets.jpg",
  "/assets/IMG-20250110-trubalcon.jpg",
  "/assets/IMG-20250110-trutongue.jpg",
  "/assets/IMG-20241222-pimubox.jpg",
  "/assets/IMG-20250110-charsits.jpg",
];

export function pickUnlockIcon(seed) {
  const n = typeof seed === "number" ? seed : new Date().getDate();
  return UNLOCK_ICONS[Math.abs(n) % UNLOCK_ICONS.length];
}
